module.exports = __webpack_public_path__ + "assets/img/29_19.d299df62.jpg";